import { yupResolver } from '@hookform/resolvers/yup'
import { QuickTipContract } from 'models/QuickTipContract'
import { TipsSettingContract } from 'models/TipsSettingContract'
import { TipsType } from 'models/TipsType'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const getDefaultQuickTips = (
    type: TipsType,
    tipSettingID: string,
): QuickTipContract => {
    return {
        amount: 0,
        type: type,
        tipsSettingID: tipSettingID,
    }
}

const useTipsSettingForm = (initialTipsSetting: TipsSettingContract) => {
    const { t } = useTranslation()

    const validation = yup.object({
        quickTips: yup.array().of(
            yup.object({
                amount: yup
                    .number()
                    .min(0)
                    .required(t('form.required', { path: 'Amount' })),
            }),
        ),
    })

    const form = useForm<TipsSettingContract>({
        defaultValues: initialTipsSetting,
        resolver: yupResolver(validation),
    })

    return form
}
export default useTipsSettingForm
